(function($) {
    
    $.OSD = function(options) { 
        this._component_name = "osd";
        // デフォルトをここで決定
        this._options = options || {};

        this._cache = [
            "abdo_location/img/button_slider.png",
            "abdo_location/img/orientation.svg",
            "abdo_location/img/location.svg",

            // slick fonts
            "css/fonts/slick.eot",
            "css/fonts/slick.svg",
            "css/fonts/slick.ttf",
            "css/fonts/slick.woff"
        ];

        this._events = {
            ready: "ready"
        }; 
 
        this._map_north = options.north || 0; 
    
        if (typeof(options.rotate_map) === "undefined") {
            this._rotate_map = false;
        }
        else {
            this._rotate_map = options.rotate_map;
        }
     
        // this._prefetch_content = new $.PrefetchContent(this._options.prefetch_content || []);
        this._overlay_options = options.overlay || {};
        if (typeof(this._overlay_options.overlays) !== 'undefined') {
            this._overlay_enabled = true; 
        } 

        this._tileSources = options.tile_sources || null;
        this._dual = options.dual || false;
        this._dual_slider = options.dual_slider || false;
        this._two_tiles = Array.isArray(this._tileSources) && this._tileSources.length == 2; 
        // this._tracker_enabled = options.tracker || false;
        // this._tracker_options = options.tracker_options || {};
     
        this.viewers = [];
    
        // containers selection
        this._containers_selectors = options.containers || ['#container'];
        this._containers = [];

        if (Array.isArray(this._containers_selectors)) {
            var i, container;

            for (i = 0; i < this._containers_selectors.length; i++) {
                container = this._containers_selectors[i];
                if (typeof(container) === 'string') {
                    container = document.querySelector(container);
                }
        
                if (container) {
                    this._containers.push(container);
                } 
            } 
        }
        else if (typeof(this._containers_selectors)  === "string") {
            // treat this._containers_selectors as a querySelector for multiple elements
            var elements = document.querySelectorAll(this._containers_selectors);
            if (elements) {
                var i;
                for (i = 0; i < elements.length; i++) {
                    this._containers.push(elements[i]);
                }
            }
        }

        this._osd_options = this._options.osd_options || {};

        // bind events listeners 
        this._slider_change = this._slider_change.bind(this);
        this._toggle_map_rotation = this._toggle_map_rotation.bind(this);
        this._handle_heading = this._handle_heading.bind(this);
        this._compass_started = this._compass_started.bind(this);
        this._compass_stopped = this._compass_stopped.bind(this);
    
        // 回転バーの無有効
        if (typeof(options.rotation_slider) === 'boolean') {
            this._rotation_slider = options.rotation_slider;
        }
        else {
            this._rotation_slider = false;
        }
    
        // 多言語の無有効、デフォルト：true
        if (typeof(options.multilanguage) === 'boolean') {
            this._multilanguage = options.multilanguage;
        }
        else {
            this._multilanguage = true;
        }
        this._multilanguage_options = options.multilanguage_options || {}; 
    
        // if has compass, handle its events
        $.on("compass_heading", this._handle_heading);
        $.on("compass_started", this._compass_started);
        $.on("compass_stopped", this._compass_stopped);
 
        // search for buttons that enable map rotation
        var toggle_map_rotation_buttons = document.querySelectorAll(".toggle-map-rotation");
        for (i = 0; i < toggle_map_rotation_buttons.length; i++) { 
            toggle_map_rotation_buttons[i].addEventListener(ABDOUtil.getClickHandler(toggle_map_rotation_buttons[i]), this._toggle_map_rotation); 
        } 

        // search for the print button (only 1), this functionality is not available on internet explorer
        var print_button = document.querySelector(".btn-print");
        if (print_button && !ABDOUtil.isIE && typeof(printJS) === "function") {
            var self = this;
            this._on(this._events.ready, function(){
                var viewers = self.viewers;
                if (viewers.length == 1) {
                    var canvas = viewers[0].canvas.querySelector("canvas");
                    if (canvas) {
                        print_button.addEventListener(ABDOUtil.getClickHandler(print_button), function(){
                            printJS({printable: canvas.toDataURL(), type: "image", imageStyle: "width:95%; margin-left:auto; margin-right:auto;"});
                        });
                    }
                }
                else if (viewers.length == 2) {
                    print_button.addEventListener(ABDOUtil.getClickHandler(print_button), function() { 

                        var canvases = [];
                        var i, viewer, canvas;
                        var total_width = 0; 
                        for(i = 0; i < viewers.length; i++) {
                            viewer = viewers[i];

                            // ignore viewer if not displaying
                            if (viewer.container.parentElement.style.display === "none") {
                                continue;
                            }

                            /** @type {HTMLCanvasElement} */
                            canvas = viewer.canvas.querySelector("canvas");

                            if (canvas) { 
                                canvases.push(canvas);
                                total_width += canvas.width;
                            }
                        }

                        var print_canvas = document.createElement("canvas");
                        print_canvas.width = total_width;
                        print_canvas.height = canvases[0].height; // assume equal height
                        var print_canvas_ctx = print_canvas.getContext("2d");
                        var width_offset=0,canvas;

                        for(i = 0; i < canvases.length; i++) {
                            canvas = canvases[i];
                            print_canvas_ctx.drawImage(canvas, width_offset, 0);
                            width_offset += canvas.width;
                        }  

                        printJS({printable: print_canvas.toDataURL(), type:"image", imageStyle: "width:95%; margin-left:auto; margin-right:auto;"});

                        // printJS({printable: printables, type: "image", imageStyle: "width:" + width});
                        // printJS({printable: "print-contents", type: "html"});
                        // document.body.removeChild(element);
                        
                    });
                }
            });
        }
        else if (print_button && ABDOUtil.isIE) {
            // show to the user
        }

        this._init_osd();

        if (this._rotation_slider && typeof(jQuery) !== 'undefined') {  
            this._rotation_slider_element = document.createElement('div');
            this._rotation_slider_element.classList.add('rotation-slider');
            var $slider = jQuery(this._rotation_slider_element);
            document.body.appendChild(this._rotation_slider_element); 

            $slider.slider({
                orientation: 'vertical',
                min: -180,
                max: 180,

                slide: this._slider_change,
                change: this._slider_change
            }); 
        }

        this._ring_element = document.querySelector("#abdo-ring");
        if (!this._ring_element) {
            this._ring_element = document.createElement("div");
            this._ring_element.classList.add("abdo-waiting");
            this._ring_element.innerHTML = '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>';
            document.body.appendChild(this._ring_element);
        }

        // if supported, keep screen active on smartphones using the wakeLock API
        if ("wakeLock" in navigator) { 
            navigator.wakeLock.request("screen"); 
        }
    };
    
    $.Component.create($.OSD, /**@lends ABDOMap.OSD.prototype */{
        // destroy: function() {
        //     var i, viewer;
        //     for(i = 0; i < this.viewers.length; i++) {
        //         viewer = this.viewers[i];
        //         viewer.destroy();
        //     }
        //     this.viewers = null;

        //      // remove compass events
        //     $.off("compass_heading", this._handle_heading);
        //     $.off("compass_started", this._compass_started);
        //     $.off("compass_stopped", this._compass_stopped);

        //     // search for buttons that enable map rotation
        //     var toggle_map_rotation_buttons = document.querySelectorAll(".toggle-map-rotation");
        //     for (i = 0; i < toggle_map_rotation_buttons.length; i++) { 
        //         toggle_map_rotation_buttons[i].removeEventListener(ABDOUtil.getClickHandler(toggle_map_rotation_buttons[i]), this._toggle_map_rotation); 
        //     }
            
        //     window.abdo_osd = undefined;
        // },

        addCache: function(paths) {
            if (typeof(paths) === "string") {
                this._cache.push(paths);
            }
            else if (Array.isArray(paths)) {
                this._cache = this._cache.concat(paths);
            }
        }, 
        

        getCache: function() { return this._cache; },

        getTileSources: function() { return this._tileSources; }, 

        _show_ring: function() {
            if (this._ring_element) {
                this._ring_element.style.display = "block";
            }
        },
        _hide_ring: function() {
            if (this._ring_element) {
                this._ring_element.style.display = "";
            }
        },
        
        _compass_started: function(compass) {
            
            if (compass._has_device_orientation) {
                var i; 
                // make orientation icon visible (if any)
                var orientation_icons = this._get_orientation_icons();
               
                for (i = 0; i < orientation_icons.length; i++) { 
                    orientation_icons[i].style.display = "block";   
                }
            }
            
        },

        _compass_stopped: function(compass) {

        },

        _slider_change: function(event, ui) {
            var i;
            for (i = 0; i < this.viewers.length; i++) {
                this.viewers[i].viewport.setRotation(ui.value);
            }
        }, 

        _set_map_angle: function(angle) {
            // when slider is present set it from there
            if (this._rotation_slider_element) {
                var $rot_slider = jQuery(this._rotation_slider_element);
                if (angle > 180) {
                    angle = angle - 360;
                }
                else if (angle < -180) {
                    angle = angle + 360;
                }
                $rot_slider.slider("value", angle); 
            }
            else {
                var i;
                // else set it directly
                for (i = 0; i < this.viewers.length; i++) { 
                    this.viewers[i].viewport.setRotation(angle);
                }
            }
        },

        _toggle_map_rotation: function() {
            this._rotate_map = !this._rotate_map;

            if(this._rotate_map) {
                var orientation_icons = this._get_orientation_icons();
                for (i = 0; i < orientation_icons.length; i++) {
                    var orientation_icon = orientation_icons[i];
                    orientation_icon.style.transform = ""; 
                }
            }
            // reset rotation
            else { 
                this._set_map_angle(0);  
            }
        },
        
        _get_orientation_icons: function() {
            return document.querySelectorAll(".abdo-orientation");
        },

        _handle_heading: function(heading) {  
 
            heading += this._map_north;
            if ("screen" in window && typeof(screen.orientation) !== "undefined") {
                heading -= screen.orientation.angle;
            }

            // keep angle cyclic
            if (heading > 360) {
                heading -= 360;
            }
            else if (heading < 0.0) {
                heading += 360;
            }

            if (this._rotate_map) {
                this._set_map_angle(heading);
            }
            else {

                if (this._rotation_slider_element) {
                    var $rot_slider = jQuery(this._rotation_slider_element);
                    heading -= $rot_slider.slider("value");
                }

                // rotate icon
                var orientation_icons = this._get_orientation_icons();
                
                if (orientation_icons) { 
                    var tr = "rotate(" + (360 - heading) +  "deg)";
    
                    for (i = 0; i < orientation_icons.length; i++) {
                        var orientation_icon = orientation_icons[i]; 
                        
                        orientation_icon.style.display = "block";
                        orientation_icon.style.transform = tr; 
                    }
                }
            }

            // ABDOUtil.display_message("heading: " + heading);

            // if (typeof(tr) !== "undefined") {
            //     element.innerText += ",tr: " + tr;
            // }

            // if (this._rotation_slider_element) {
            //     var $rot_slider = jQuery(this._rotation_slider_element);
            //     element.innerText += ",slider: " + $rot_slider.slider("value") ;
            // }
        }, 

        init: function() {
            if (this._multilanguage) { 
                this.i18n = new $.I18n(this._multilanguage_options);
            }
        },

        _view_canvas_img: function() {
            if (this.viewers.length > 0 ) {
                var canvas_element = this.viewers[0].canvas.querySelector("canvas");
                var dataURL = canvas_element.toDataURL("image/png");
                var new_tab = window.open('about:blank','image from canvas');
                new_tab.document.write("<img src='" + dataURL + "' />");
            }
        },

        _view_canvas: function(canvas_element) { 
            var dataURL = canvas_element.toDataURL("image/png");
            var new_tab = window.open('about:blank','image from canvas');
            new_tab.document.write("<img src='" + dataURL + "' />"); 
        },

        _init_osd: function() {
            // キャンバスにかけるように
			// OpenSeadragon.pixelDensityRatio = 1.0;

			OpenSeadragon.setString("Tooltips.Home", "最初の状態に戻す");
			OpenSeadragon.setString("Tooltips.ZoomOut", "縮小");
			OpenSeadragon.setString("Tooltips.ZoomIn", "拡大");
			OpenSeadragon.setString("Tooltips.FullPage", "画面いっぱいに広げる");
			OpenSeadragon.setString("Tooltips.NextPage", "次のページに進む");
			OpenSeadragon.setString("Tooltips.PreviousPage", "前のページに戻る");
			OpenSeadragon.setString("Tooltips.RotateLeft", "左に回転");
			OpenSeadragon.setString("Tooltips.RotateRight", "右に回転"); 

            var options = {
				prefixUrl: "openseadragon-bin-3.0.0/images/",
				showNavigator: false, // todo: builder options へ
                showNavigationControl: true, // todo:  builder options へ
				navigatorMaintainSizeRatio: true,
				maxZoomPixelRatio: 2.0,
				minZoomImageRatio: 0.5,
				sequenceMode: false,
				showReferenceStrip: false,
				preserveViewport: false,
				preserveImageSizeOnResize: false,
				defaultZoomLevel: 0.7,
				blendTime: 0.0,
				immediateRender: false,
				minScrollDeltaTime: 10,
				animationTime: 0.1,
				showZoomControl: false,
				showHomeControl: false,
				showFullPageControl: false,
				showRotationControl: false,
                navPrevNextWrap: false,
                crossOriginPolicy: "Anonymous",

                // same as google maps
                gestureSettingsMouse: {
                    clickToZoom: false,
                    dblClickToZoom: true
                },
            };
            
            // パラメータに渡したOpenSeadragonの設定を書き込む
            for(var prop in this._osd_options) {
                if (this._osd_options.hasOwnProperty(prop)) {
                    options[prop] = this._osd_options[prop];
                }
            }
  
             
            var self = this;
            var cloned_options, viewer;
            if (this._two_tiles) {
                if (this._dual_slider && this._containers.length == 1) {
                    // containerとviewerはそれぞれ一つが必要です 
                    cloned_options = ABDOUtil.clone(options);
                    cloned_options.id = this._containers[0].id;
                    // console.dir(cloned_options);
                    if (this._overlay_enabled) {
                        cloned_options.overlays = this._overlay_options.overlays;
                    }
                    viewer = this._add_viewer(cloned_options);
    
                    this.abdo_dual = new $.DualMap({
                        containers: this._containers,
                        viewers: this.viewers,
                        tile_source_left: this._tileSources[0],
                        tile_source_right: this._tileSources[1],
                    });
    
                    this.abdo_dual.on('loaded', function() {
                        self._osd_ready.call(self);
                    });
                }
                // container二つが必要
                else if (this._dual && this._containers.length == 2) {
                    // OSDの初期化
                    for (var i = 0; i < this._containers.length; i++) {
                        cloned_options = ABDOUtil.clone(options); // Deep copy
                        cloned_options.id = this._containers[i].id;
                        if (this._overlay_enabled) {
                            cloned_options.overlays = this._overlay_options.overlays;
                        }
                        viewer = this._add_viewer(cloned_options);
                    }
    
                    this.abdo_dual = new $.DualMap({
                        containers: this._containers,
                        viewers: this.viewers,
                        tile_source_left: this._tileSources[0],
                        tile_source_right: this._tileSources[1],
                    });
    
                    this.abdo_dual.on('loaded', function() {
                        self._osd_ready.call(self);
                    });
                }
            }
            else {
                options.id = this._containers[0].id;
                viewer = this._add_viewer(options);
                
                viewer.addTiledImage( {
                    tileSource: this._tileSources[0],
                    success: function( event ) {
                        self._osd_ready.call(self);
                    } 
                });
            }  
        },

        _add_viewer: function(options) {
            var viewer = OpenSeadragon(options);
            var abdo = {};
            viewer.abdo = abdo;
            abdo.osd_canvas = viewer.canvas.querySelector("canvas");
            abdo.layers = [];
            this.viewers.push(viewer);

            viewer.addHandler("update-viewport", this._on_viewer_draw);
            return viewer;
        },

        _on_viewer_draw: function(event) {
            var abdo = event.eventSource.abdo;
            var ctx = abdo.osd_canvas.getContext("2d");
            var i, canvas, viewers_n=abdo.layers.length;
            for(i = 0; i < viewers_n; i++) {
                canvas = abdo.layers[i];
                // if (abdo.osd_canvas.width == canvas.width && abdo.osd_canvas.height == abdo.osd_canvas.height) {
                    ctx.drawImage(canvas, 0, 0);
                // }
            }
        },

        _init_tracker: function() {
            this._tracker_options.viewers = this.viewers;
            this.tracker = new $.Tracker(this._tracker_options);
            this.tracker.init();
        },


        _init_overlay: function() {
            this._overlay_options.viewers = this.viewers;
            if (typeof(this.tracker) !== 'undefined') {
                this._overlay_options.tracker = this.tracker;
            }
            this.overlay = new $.Overlay(this._overlay_options);
        },

        _osd_ready: function() {
            for (var v_index = 0; v_index < this.viewers.length; v_index++) {
                this.viewers[v_index].viewport.goHome(); 
            }

            this._process_url_actions();

            $.Component.call(this, $.OSD);

            this._emit(this._events.ready);
        },

        _process_url_actions: function() {
            var params = location.search;
            if (location.search !== "") {
                var params = new URLSearchParams(location.search);
                var action = params.get("action");
                if (action === "pin") {
                    this._action_pin(params);
                }
            }
        },

        _action_pin: function(params) { 
            var size = Number(params.get("size") || 30);
            var range = Number(params.get("range") || 500);
            var nearest_place = params.get("nearest");
            var title = params.get("title");
            

            if (params.has("x") && !params.has("lat")) {
                //only viewport
            }
            else if (params.has("lat")) {
                // if it has lat/lon coordinates convert them to vp and add
                var lat = Number(params.get("lat"));
                var lon = Number(params.get("lon")); 
                // wait until location_provider is ready
                $.once("location_provider_ready", function() { 
                   
                    var i, viewer;
                    for(i = 0; i < this.viewers.length; i++) {
                        viewer = this.viewers[i];
                        var localization = viewer.abdo.localization;
                        var xy = localization.lonlat2vp(lon, lat);
                        var pt = new OpenSeadragon.Point(xy[0], xy[1]); 

                        viewer.addOverlay({
                            element: this._get_pin_element(i, title),
                            x: pt.x,
                            y: pt.y,
                            width: 0.01,
                            height: 0.01,
                            onDraw: this._on_draw_overlay_fixed_size.bind(this, size)
                        });

                        if (i == 0) {
                            var scale = localization.get_scale();
                            var radius = range / scale;
                            var rect = new OpenSeadragon.Rect(pt.x - radius, pt.y - radius, radius*2, radius*2);

                            viewer.viewport.fitBounds(rect); 
                        }

                    } 
                     
                }.bind(this));
            } 
        }, 

        _on_draw_overlay_fixed_size: function (fixed_size, position, size, element) {   
            /** @type {OpenSeadragon.Viewer} */
            var viewer = this.viewers[0];
            var bounds = viewer.viewport.getBounds();
            var position_vp = viewer.viewport.pointFromPixel(position);
            
            if (bounds.containsPoint(position_vp)) {
                element.classList.remove("d-none");
            }
            else {
                element.classList.add("d-none");
                return;
            }

            element.style.width = fixed_size + "px";
            element.style.height = fixed_size + "px";

            // top and left set to 0 to use CSS translate later
            if (!element.style.left) {
                element.style.left = '0px';
            }

            if (!element.style.top) {
                element.style.top = '0px';
            } 
 
            var x = Math.floor(position.x);
            var y = Math.floor(position.y);
            var translation = 'translate(' + x + 'px, ' + y + 'px)';
            element.style.transform = translation;   
        },

        _get_pin_element: function(viewer_index, title) {
            var pin_element = document.querySelector("div#pin-" + viewer_index)
            if (!pin_element) {
                pin_element = this._create_pin_element(viewer_index, title);
            }
            else {    
                var title_element = pin_element.querySelector("h5");
                title_element.innerText = title;
            }


            return pin_element;
        },

        _create_pin_element: function(viewer_index, title) {
            var pin_element = document.createElement("div");
            pin_element.classList.add("pin");
            pin_element.id = "pin-" + viewer_index;
            
            var pin_icon = document.createElement("div");
            pin_icon.classList.add("pin-icon"); 
            pin_element.appendChild(pin_icon);

            var pin_title = document.createElement("h5");
            pin_title.classList.add("pin-title");
            pin_title.innerText = title;
            pin_element.appendChild(pin_title);

            document.body.appendChild(pin_element);

            return pin_element;
        },

        on: function(event, fun) {
            this._on(event, fun);
        },

        reset: function() {
            for (const viewer of this.viewers) {
                viewer.destroy();
            }

            if (this.tracker && this.tracker.osm_overlay) {
                this.tracker.osm_overlay.destroy();
            }

            this._callbacks = [];
            $._callbacks = [];
        }
    });
 
})(ABDOMap);